module.exports = __webpack_public_path__ + "static/battle03-sq-e67f8258b1f2099d686c996d4c60cdc1.png";